module.exports = __webpack_public_path__ + "static/media/Analitycs.3b949cb3.svg";